module.exports = __webpack_public_path__ + "static/media/tessellana_veyseli_006_APA.64e0f759.mp3";